__webpack_require__.p = "https://certificate.quantstamp.com/full/flow-core-contract/de31217b-4067-4aa2-81d6-261451a72428/";